/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { type Observable } from 'rxjs';
import { type ChatEnvironment } from '../interfaces/chat-environment';
import { type ItscMessageResponse } from '../interfaces/itsc-message-response';
import { type ItscRateResponse } from '../interfaces/itsc-rate-response';
import { ChatService } from './chat.service';

@Injectable({ providedIn: 'any' })
export class ApiService {
    private readonly chatService = inject(ChatService);
    private readonly environment: ChatEnvironment = {
        api: {
            host: '/',
            path: 'api/big_chat',
        },
    };
    private readonly http = inject(HttpClient);

    public conversation(message: string): Observable<ItscMessageResponse[]> {
        return this.http.post<ItscMessageResponse[]>(
            `${this.environment.api.host}${this.environment.api.path}/conversation`,
            {
                message,
                sessionId: this.chatService.config().user.token,
            },
            {
                withCredentials: true,
            },
        );
    }

    public rateConversation(rating: number): Observable<ItscRateResponse[]> {
        return this.http.post<ItscRateResponse[]>(
            `${this.environment.api.host}${this.environment.api.path}/conversation/rate`,
            {
                rating,
                sessionId: this.chatService.config().user.token,
            },
            {
                withCredentials: true,
            },
        );
    }
}
